import { render } from "./OrderProfileCompany.vue?vue&type=template&id=826918d6&scoped=true"
import script from "./OrderProfileCompany.vue?vue&type=script&lang=js"
export * from "./OrderProfileCompany.vue?vue&type=script&lang=js"

import "./OrderProfileCompany.vue?vue&type=style&index=0&id=826918d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-826918d6"]])

export default __exports__